import { css } from 'styled-components';
import { cellStyles, cellMargin, cellMarginY, offsetStyles } from '../Grid.constants';
export default css `
  flex: 0 0 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;

  .grid-margin > && {
    ${cellMargin}
  }

  .grid-margin-y > && {
    ${cellMarginY}
  }

  ${({ auto }) => auto &&
    css `
      flex: 1 1 0px;
      width: auto;
    `}
  ${(props) => css `
    .grid-x > && {
      ${cellStyles(props)}
    }
    .grid-y > && {
      ${cellStyles(props, true)}
    }
  `}

  ${({ shrink }) => shrink &&
    css `
      width: auto;
    `}

  ${({ center }) => center &&
    css `
      margin-left: auto;
      margin-right: auto;
    `}

  ${(props) => props.offset && offsetStyles(props, props.offset)}
  ${(props) => props.offsetRight && offsetStyles(props, props.offsetRight, 'right')}
`;
